import { useState, useEffect } from "react";

const navItems = [
  { id: "processing-options", label: "Processing Options" },
  { id: "services", label: "Services" },
  { id: "service-area", label: "Service Area" },
  { id: "acceptance-facilities", label: "Acceptance Clerks" },
  { id: "comparison", label: "vs. Regional Agency" },
  { id: "faq", label: "FAQ" },
  { id: "local-resources", label: "Local Resources" },
];

export default function FlorenceStickyNav() {
  const [active, setActive] = useState("");
  useEffect(() => {
    const handleScroll = () => {
      const ids = navItems.map((item) => item.id);
      for (let i = ids.length - 1; i >= 0; i--) {
        const el = document.getElementById(ids[i]);
        if (el && el.getBoundingClientRect().top <= 130) { setActive(ids[i]); return; }
      }
      setActive("");
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return (
    <nav className="sticky top-[70px] z-40 bg-white border-b border-gray-200 overflow-x-auto">
      <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center gap-1.5 py-2.5">
        {navItems.map((item) => (
          <a key={item.id} href={`#${item.id}`} className={`px-4 py-1.5 rounded-full text-sm font-medium whitespace-nowrap transition-all cursor-pointer ${active === item.id ? "bg-[#1A365D] text-white" : "text-gray-500 hover:bg-[#EEF2F8] hover:text-[#1A365D]"}`}>{item.label}</a>
        ))}
      </div>
    </nav>
  );
}